import React from 'react';
import { Divider, StepTracker, Typography } from '@telus-uds/components-web';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  keySecureBusiness,
  keySecureBusinessFr,
  QuoteSummaryFr,
  QuoteSummaryEn,
  STEP_TRACKER_DICTIONARY
} from '../utils/constant';
import { localeFr } from '../misc';

const ProgressBar = ({ name, steps, currentStep = 0, locale, formName }) => {
  let progressSteps;

  if (
    locale === localeFr &&
    [keySecureBusiness, QuoteSummaryFr, QuoteSummaryEn].includes(name)
  ) {
    progressSteps = steps.map(item => _.get(item, 'fields.name', ''));
    const findIdx = progressSteps.indexOf(keySecureBusiness);
    progressSteps[findIdx] = keySecureBusinessFr;
  } else {
    progressSteps = steps.map(item => _.get(item, 'fields.name', ''));
  }
  return (
    <div>
      <div className="container 85%">
        <div id="title">
          <div id="title-wrapper">
            <div style={{ paddingTop: '2em' }}>
              <Typography heading="h2" variant={{ size: 'h2' }} block>
                <div id="title-label">
                  {formName === 'Fully_Managed_Form' ? 'Proposal' : name}
                </div>
              </Typography>
              <div id="title-anchors" style={{ marginTop: '10px' }} />
            </div>
          </div>
        </div>
        {steps && steps.length > 1 && (
          <StepTracker
            copy="en"
            current={currentStep - 1}
            steps={progressSteps}
            dictionary={STEP_TRACKER_DICTIONARY}
          />
        )}
        <Divider space={2} variant={{ inverse: true }}/>
      </div>
    </div>
  );  
};

ProgressBar.propTypes = {
  name: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  locale: PropTypes.string.isRequired
};

export default ProgressBar;
